import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const users: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do usuário',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default users;
